import { render, staticRenderFns } from "./ComputerCart.vue?vue&type=template&id=15e4e873&scoped=true&"
import script from "./ComputerCart.vue?vue&type=script&lang=js&"
export * from "./ComputerCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e4e873",
  null
  
)

export default component.exports